import { LocaleEnum } from '@vini-wine/core-enums';
export const isSupportedLocale = (locale) => {
    switch (locale) {
        case LocaleEnum.CHINESE:
        case LocaleEnum.SPANISH:
        case LocaleEnum.ITALIAN:
        case LocaleEnum.FRENCH:
        case LocaleEnum.RUSSIAN:
        case LocaleEnum.DUTCH:
        case LocaleEnum.ENGLISH:
            return true;
        default:
            return false;
    }
};
export const localeName = (locale) => {
    switch (locale) {
        case LocaleEnum.AFAR:
            return 'Afar';
        case LocaleEnum.ABKHAZIAN:
            return 'Abkhazian';
        case LocaleEnum.AFRIKAANS:
            return 'Afrikaans';
        case LocaleEnum.AKAN:
            return 'Akan';
        case LocaleEnum.ALBANIAN:
            return 'Albanian';
        case LocaleEnum.AMHARIC:
            return 'Amharic';
        case LocaleEnum.ARABIC:
            return 'Arabic';
        case LocaleEnum.ARAGONESE:
            return 'Aragonese';
        case LocaleEnum.ASSAMESE:
            return 'Assamese';
        case LocaleEnum.AVARIC:
            return 'Avaric';
        case LocaleEnum.AVESTAN:
            return 'Avestan';
        case LocaleEnum.AYMARA:
            return 'Aymara';
        case LocaleEnum.AZERBAIJANI:
            return 'Azerbaijani';
        case LocaleEnum.BAMBARA:
            return 'Bambara';
        case LocaleEnum.BASHKIR:
            return 'Bashkir';
        case LocaleEnum.BASQUE:
            return 'Basque';
        case LocaleEnum.BELARUSIAN:
            return 'Belarusian';
        case LocaleEnum.BENGALI:
            return 'Bengali';
        case LocaleEnum.BIHARI_LANGUAGES:
            return 'Bihari languages';
        case LocaleEnum.BISLAMA:
            return 'Bislama';
        case LocaleEnum.BOSNIAN:
            return 'Bosnian';
        case LocaleEnum.BRETON:
            return 'Breton';
        case LocaleEnum.BULGARIAN:
            return 'Bulgarian';
        case LocaleEnum.BURMESE:
            return 'Burmese';
        case LocaleEnum.CATALAN:
            return 'Catalan';
        case LocaleEnum.CHAMORRO:
            return 'Chamorro';
        case LocaleEnum.CHECHEN:
            return 'Chechen';
        case LocaleEnum.CHICHEWA:
            return 'Chichewa';
        case LocaleEnum.CHINESE:
            return 'Chinese';
        case LocaleEnum.CHUVASH:
            return 'Chuvash';
        case LocaleEnum.CORNISH:
            return 'Cornish';
        case LocaleEnum.CORSICAN:
            return 'Corsican';
        case LocaleEnum.CREE:
            return 'Cree';
        case LocaleEnum.CROATIAN:
            return 'Croatian';
        case LocaleEnum.CZECH:
            return 'Czech';
        case LocaleEnum.DANISH:
            return 'Danish';
        case LocaleEnum.DIVEHI:
            return 'Divehi';
        case LocaleEnum.DUTCH:
            return 'Dutch';
        case LocaleEnum.DZONGKHA:
            return 'Dzongkha';
        case LocaleEnum.ENGLISH:
            return 'English';
        case LocaleEnum.ESPERANTO:
            return 'Esperanto';
        case LocaleEnum.ESTONIAN:
            return 'Estonian';
        case LocaleEnum.EWE:
            return 'Ewe';
        case LocaleEnum.FAROESE:
            return 'Faroese';
        case LocaleEnum.FIJIAN:
            return 'Fijian';
        case LocaleEnum.FINNISH:
            return 'Finnish';
        case LocaleEnum.FRENCH:
            return 'French';
        case LocaleEnum.FULAH:
            return 'Fulah';
        case LocaleEnum.GALICIAN:
            return 'Galician';
        case LocaleEnum.GANDA:
            return 'Ganda';
        case LocaleEnum.GEORGIAN:
            return 'Georgian';
        case LocaleEnum.GERMAN:
            return 'German';
        case LocaleEnum.GREEK:
            return 'Greek';
        case LocaleEnum.GUARANI:
            return 'Guarani';
        case LocaleEnum.GUJARATI:
            return 'Gujarati';
        case LocaleEnum.HAITIAN:
            return 'Haitian';
        case LocaleEnum.HAUSA:
            return 'Hausa';
        case LocaleEnum.HEBREW:
            return 'Hebrew';
        case LocaleEnum.HERERO:
            return 'Herero';
        case LocaleEnum.HINDI:
            return 'Hindi';
        case LocaleEnum.HIRI_MOTU:
            return 'Hiri Motu';
        case LocaleEnum.HUNGARIAN:
            return 'Hungarian';
        case LocaleEnum.ICELANDIC:
            return 'Icelandic';
        case LocaleEnum.IDO:
            return 'Ido';
        case LocaleEnum.IGBO:
            return 'Igbo';
        case LocaleEnum.INDONESIAN:
            return 'Indonesian';
        case LocaleEnum.INTERLINGUA:
            return 'Interlingua';
        case LocaleEnum.INTERLINGUE:
            return 'Interlingue';
        case LocaleEnum.INUKTITUT:
            return 'Inuktitut';
        case LocaleEnum.INUPIAQ:
            return 'Inupiaq';
        case LocaleEnum.IRISH:
            return 'Irish';
        case LocaleEnum.ITALIAN:
            return 'Italian';
        case LocaleEnum.JAPANESE:
            return 'Japanese';
        case LocaleEnum.JAVANESE:
            return 'Javanese';
        case LocaleEnum.KALAALLISUT:
            return 'Kalaallisut';
        case LocaleEnum.KANNADA:
            return 'Kannada';
        case LocaleEnum.KANURI:
            return 'Kanuri';
        case LocaleEnum.KASHMIRI:
            return 'Kashmiri';
        case LocaleEnum.KAZAKH:
            return 'Kazakh';
        case LocaleEnum.KHMER:
            return 'Khmer';
        case LocaleEnum.KIKUYU:
            return 'Kikuyu';
        case LocaleEnum.KINYARWANDA:
            return 'Kinyarwanda';
        case LocaleEnum.KIRGHIZ:
            return 'Kirghiz';
        case LocaleEnum.KOMI:
            return 'Komi';
        case LocaleEnum.KONGO:
            return 'Kongo';
        case LocaleEnum.KOREAN:
            return 'Korean';
        case LocaleEnum.KUANYAMA:
            return 'Kuanyama';
        case LocaleEnum.KURDISH:
            return 'Kurdish';
        case LocaleEnum.LAO:
            return 'Lao';
        case LocaleEnum.LATIN:
            return 'Latin';
        case LocaleEnum.LATVIAN:
            return 'Latvian';
        case LocaleEnum.LIMBURGAN:
            return 'Limburgan';
        case LocaleEnum.LINGALA:
            return 'Lingala';
        case LocaleEnum.LITHUANIAN:
            return 'Lithuanian';
        case LocaleEnum.LUBA_KATANGA:
            return 'Luba-Katanga';
        case LocaleEnum.LUXEMBOURGISH:
            return 'Luxembourgish';
        case LocaleEnum.MACEDONIAN:
            return 'Macedonian';
        case LocaleEnum.MALAGASY:
            return 'Malagasy';
        case LocaleEnum.MALAY:
            return 'Malay';
        case LocaleEnum.MALAYALAM:
            return 'Malayalam';
        case LocaleEnum.MALTESE:
            return 'Maltese';
        case LocaleEnum.MANX:
            return 'Manx';
        case LocaleEnum.MAORI:
            return 'Maori';
        case LocaleEnum.MARATHI:
            return 'Marathi';
        case LocaleEnum.MARSHALLESE:
            return 'Marshallese';
        case LocaleEnum.MONGOLIAN:
            return 'Mongolian';
        case LocaleEnum.NAURU:
            return 'Nauru';
        case LocaleEnum.NAVAJO:
            return 'Navajo';
        case LocaleEnum.NDEBELE:
            return 'Ndebele';
        case LocaleEnum.NDONGA:
            return 'Ndonga';
        case LocaleEnum.NEPALI:
            return 'Nepali';
        case LocaleEnum.NORTH_NDEBELE:
            return 'North Ndebele';
        case LocaleEnum.NORTHERN_SAMI:
            return 'Northern Sami';
        case LocaleEnum.NORWEGIAN:
            return 'Norwegian';
        case LocaleEnum.NORWEGIAN_BOKMAL:
            return 'Norwegian Bokmål';
        case LocaleEnum.NORWEGIAN_NYNORSK:
            return 'Norwegian Nynorsk';
        case LocaleEnum.NUOSU:
            return 'Nuosu';
        case LocaleEnum.OCCITAN:
            return 'Occitan';
        case LocaleEnum.OJIBWE:
            return 'Ojibwe';
        case LocaleEnum.OLD_CHURCH_SLAVONIC:
            return 'Old Church Slavonic';
        case LocaleEnum.ORIYA:
            return 'Oriya';
        case LocaleEnum.OROMO:
            return 'Oromo';
        case LocaleEnum.OSSETIAN:
            return 'Ossetian';
        case LocaleEnum.PALI:
            return 'Pali';
        case LocaleEnum.PANJABI:
            return 'Panjabi';
        case LocaleEnum.PASHTO:
            return 'Pashto';
        case LocaleEnum.PERSIAN:
            return 'Persian';
        case LocaleEnum.POLISH:
            return 'Polish';
        case LocaleEnum.PORTUGUESE:
            return 'Portuguese';
        case LocaleEnum.QUECHUA:
            return 'Quechua';
        case LocaleEnum.ROMANSH:
            return 'Romansh';
        case LocaleEnum.ROMANIAN:
            return 'Romanian';
        case LocaleEnum.RUNDI:
            return 'Rundi';
        case LocaleEnum.RUSSIAN:
            return 'Russian';
        case LocaleEnum.SAMOAN:
            return 'Samoan';
        case LocaleEnum.SANGO:
            return 'Sango';
        case LocaleEnum.SANSKRIT:
            return 'Sanskrit';
        case LocaleEnum.SARDINIAN:
            return 'Sardinian';
        case LocaleEnum.SERBIAN:
            return 'Serbian';
        case LocaleEnum.SHONA:
            return 'Shona';
        case LocaleEnum.SINDHI:
            return 'Sindhi';
        case LocaleEnum.SINHALA:
            return 'Sinhala';
        case LocaleEnum.SLOVAK:
            return 'Slovak';
        case LocaleEnum.SLOVENIAN:
            return 'Slovenian';
        case LocaleEnum.SOMALI:
            return 'Somali';
        case LocaleEnum.SOUTHERN_SOTHO:
            return 'Southern Sotho';
        case LocaleEnum.SPANISH:
            return 'Spanish';
        case LocaleEnum.SUNDANESE:
            return 'Sundanese';
        case LocaleEnum.SWAHILI:
            return 'Swahili';
        case LocaleEnum.SWATI:
            return 'Swati';
        case LocaleEnum.SWEDISH:
            return 'Swedish';
        case LocaleEnum.TAGALOG:
            return 'Tagalog';
        case LocaleEnum.TAHITIAN:
            return 'Tahitian';
        case LocaleEnum.TAJIK:
            return 'Tajik';
        case LocaleEnum.TAMIL:
            return 'Tamil';
        case LocaleEnum.TATAR:
            return 'Tatar';
        case LocaleEnum.TELUGU:
            return 'Telugu';
        case LocaleEnum.THAI:
            return 'Thai';
        case LocaleEnum.TIBETAN:
            return 'Tibetan';
        case LocaleEnum.TIGRINYA:
            return 'Tigrinya';
        case LocaleEnum.TONGA:
            return 'Tonga';
        case LocaleEnum.TSONGA:
            return 'Tsonga';
        case LocaleEnum.TSWANA:
            return 'Tswana';
        case LocaleEnum.TURKISH:
            return 'Turkish';
        case LocaleEnum.TURKMEN:
            return 'Turkmen';
        case LocaleEnum.TWI:
            return 'Twi';
        case LocaleEnum.UIGHUR:
            return 'Uighur';
        case LocaleEnum.UKRAINIAN:
            return 'Ukrainian';
        case LocaleEnum.URDU:
            return 'Urdu';
        case LocaleEnum.UZBEK:
            return 'Uzbek';
        case LocaleEnum.VENDA:
            return 'Venda';
        case LocaleEnum.VIETNAMESE:
            return 'Vietnamese';
        case LocaleEnum.VOLAPUK:
            return 'Volapük';
        case LocaleEnum.WALLOON:
            return 'Walloon';
        case LocaleEnum.WELSH:
            return 'Welsh';
        case LocaleEnum.WESTERN_FRISIAN:
            return 'Western Frisian';
        case LocaleEnum.WOLOF:
            return 'Wolof';
        case LocaleEnum.XHOSA:
            return 'Xhosa';
        case LocaleEnum.YIDDISH:
            return 'Yiddish';
        case LocaleEnum.YORUBA:
            return 'Yoruba';
        case LocaleEnum.ZHUANG:
            return 'Zhuang';
        case LocaleEnum.ZULU:
            return 'Zulu';
        default:
            return 'Unsupported';
    }
};
export const getSupportedLocales = () => [
    {
        locale: LocaleEnum.CHINESE,
        name: localeName(LocaleEnum.CHINESE),
    },
    {
        locale: LocaleEnum.DUTCH,
        name: localeName(LocaleEnum.DUTCH),
    },
    {
        locale: LocaleEnum.ENGLISH,
        name: localeName(LocaleEnum.ENGLISH),
    },
    {
        locale: LocaleEnum.FRENCH,
        name: localeName(LocaleEnum.FRENCH),
    },
    {
        locale: LocaleEnum.ITALIAN,
        name: localeName(LocaleEnum.ITALIAN),
    },
    {
        locale: LocaleEnum.PORTUGUESE,
        name: localeName(LocaleEnum.PORTUGUESE),
    },
    {
        locale: LocaleEnum.RUSSIAN,
        name: localeName(LocaleEnum.RUSSIAN),
    },
    {
        locale: LocaleEnum.SPANISH,
        name: localeName(LocaleEnum.SPANISH),
    },
];
export const getAllLocales = () => [
    { locale: LocaleEnum.AFAR, name: localeName(LocaleEnum.AFAR) },
    { locale: LocaleEnum.ABKHAZIAN, name: localeName(LocaleEnum.ABKHAZIAN) },
    { locale: LocaleEnum.AFRIKAANS, name: localeName(LocaleEnum.AFRIKAANS) },
    { locale: LocaleEnum.AKAN, name: localeName(LocaleEnum.AKAN) },
    { locale: LocaleEnum.ALBANIAN, name: localeName(LocaleEnum.ALBANIAN) },
    { locale: LocaleEnum.AMHARIC, name: localeName(LocaleEnum.AMHARIC) },
    { locale: LocaleEnum.ARABIC, name: localeName(LocaleEnum.ARABIC) },
    { locale: LocaleEnum.ARAGONESE, name: localeName(LocaleEnum.ARAGONESE) },
    { locale: LocaleEnum.ASSAMESE, name: localeName(LocaleEnum.ASSAMESE) },
    { locale: LocaleEnum.AVARIC, name: localeName(LocaleEnum.AVARIC) },
    { locale: LocaleEnum.AVESTAN, name: localeName(LocaleEnum.AVESTAN) },
    { locale: LocaleEnum.AYMARA, name: localeName(LocaleEnum.AYMARA) },
    { locale: LocaleEnum.AZERBAIJANI, name: localeName(LocaleEnum.AZERBAIJANI) },
    { locale: LocaleEnum.BAMBARA, name: localeName(LocaleEnum.BAMBARA) },
    { locale: LocaleEnum.BASHKIR, name: localeName(LocaleEnum.BASHKIR) },
    { locale: LocaleEnum.BASQUE, name: localeName(LocaleEnum.BASQUE) },
    { locale: LocaleEnum.BELARUSIAN, name: localeName(LocaleEnum.BELARUSIAN) },
    { locale: LocaleEnum.BENGALI, name: localeName(LocaleEnum.BENGALI) },
    { locale: LocaleEnum.BIHARI_LANGUAGES, name: localeName(LocaleEnum.BIHARI_LANGUAGES) },
    { locale: LocaleEnum.BISLAMA, name: localeName(LocaleEnum.BISLAMA) },
    { locale: LocaleEnum.BOSNIAN, name: localeName(LocaleEnum.BOSNIAN) },
    { locale: LocaleEnum.BRETON, name: localeName(LocaleEnum.BRETON) },
    { locale: LocaleEnum.BULGARIAN, name: localeName(LocaleEnum.BULGARIAN) },
    { locale: LocaleEnum.BURMESE, name: localeName(LocaleEnum.BURMESE) },
    { locale: LocaleEnum.CATALAN, name: localeName(LocaleEnum.CATALAN) },
    { locale: LocaleEnum.CHAMORRO, name: localeName(LocaleEnum.CHAMORRO) },
    { locale: LocaleEnum.CHECHEN, name: localeName(LocaleEnum.CHECHEN) },
    { locale: LocaleEnum.CHICHEWA, name: localeName(LocaleEnum.CHICHEWA) },
    { locale: LocaleEnum.CHINESE, name: localeName(LocaleEnum.CHINESE) },
    { locale: LocaleEnum.CHUVASH, name: localeName(LocaleEnum.CHUVASH) },
    { locale: LocaleEnum.CORNISH, name: localeName(LocaleEnum.CORNISH) },
    { locale: LocaleEnum.CORSICAN, name: localeName(LocaleEnum.CORSICAN) },
    { locale: LocaleEnum.CREE, name: localeName(LocaleEnum.CREE) },
    { locale: LocaleEnum.CROATIAN, name: localeName(LocaleEnum.CROATIAN) },
    { locale: LocaleEnum.CZECH, name: localeName(LocaleEnum.CZECH) },
    { locale: LocaleEnum.DANISH, name: localeName(LocaleEnum.DANISH) },
    { locale: LocaleEnum.DIVEHI, name: localeName(LocaleEnum.DIVEHI) },
    { locale: LocaleEnum.DUTCH, name: localeName(LocaleEnum.DUTCH) },
    { locale: LocaleEnum.DZONGKHA, name: localeName(LocaleEnum.DZONGKHA) },
    { locale: LocaleEnum.ENGLISH, name: localeName(LocaleEnum.ENGLISH) },
    { locale: LocaleEnum.ESPERANTO, name: localeName(LocaleEnum.ESPERANTO) },
    { locale: LocaleEnum.ESTONIAN, name: localeName(LocaleEnum.ESTONIAN) },
    { locale: LocaleEnum.EWE, name: localeName(LocaleEnum.EWE) },
    { locale: LocaleEnum.FAROESE, name: localeName(LocaleEnum.FAROESE) },
    { locale: LocaleEnum.FIJIAN, name: localeName(LocaleEnum.FIJIAN) },
    { locale: LocaleEnum.FINNISH, name: localeName(LocaleEnum.FINNISH) },
    { locale: LocaleEnum.FRENCH, name: localeName(LocaleEnum.FRENCH) },
    { locale: LocaleEnum.FULAH, name: localeName(LocaleEnum.FULAH) },
    { locale: LocaleEnum.GALICIAN, name: localeName(LocaleEnum.GALICIAN) },
    { locale: LocaleEnum.GANDA, name: localeName(LocaleEnum.GANDA) },
    { locale: LocaleEnum.GEORGIAN, name: localeName(LocaleEnum.GEORGIAN) },
    { locale: LocaleEnum.GERMAN, name: localeName(LocaleEnum.GERMAN) },
    { locale: LocaleEnum.GREEK, name: localeName(LocaleEnum.GREEK) },
    { locale: LocaleEnum.GUARANI, name: localeName(LocaleEnum.GUARANI) },
    { locale: LocaleEnum.GUJARATI, name: localeName(LocaleEnum.GUJARATI) },
    { locale: LocaleEnum.HAITIAN, name: localeName(LocaleEnum.HAITIAN) },
    { locale: LocaleEnum.HAUSA, name: localeName(LocaleEnum.HAUSA) },
    { locale: LocaleEnum.HEBREW, name: localeName(LocaleEnum.HEBREW) },
    { locale: LocaleEnum.HERERO, name: localeName(LocaleEnum.HERERO) },
    { locale: LocaleEnum.HINDI, name: localeName(LocaleEnum.HINDI) },
    { locale: LocaleEnum.HIRI_MOTU, name: localeName(LocaleEnum.HIRI_MOTU) },
    { locale: LocaleEnum.HUNGARIAN, name: localeName(LocaleEnum.HUNGARIAN) },
    { locale: LocaleEnum.ICELANDIC, name: localeName(LocaleEnum.ICELANDIC) },
    { locale: LocaleEnum.IDO, name: localeName(LocaleEnum.IDO) },
    { locale: LocaleEnum.IGBO, name: localeName(LocaleEnum.IGBO) },
    { locale: LocaleEnum.INDONESIAN, name: localeName(LocaleEnum.INDONESIAN) },
    { locale: LocaleEnum.INTERLINGUA, name: localeName(LocaleEnum.INTERLINGUA) },
    { locale: LocaleEnum.INTERLINGUE, name: localeName(LocaleEnum.INTERLINGUE) },
    { locale: LocaleEnum.INUKTITUT, name: localeName(LocaleEnum.INUKTITUT) },
    { locale: LocaleEnum.INUPIAQ, name: localeName(LocaleEnum.INUPIAQ) },
    { locale: LocaleEnum.IRISH, name: localeName(LocaleEnum.IRISH) },
    { locale: LocaleEnum.ITALIAN, name: localeName(LocaleEnum.ITALIAN) },
    { locale: LocaleEnum.JAPANESE, name: localeName(LocaleEnum.JAPANESE) },
    { locale: LocaleEnum.JAVANESE, name: localeName(LocaleEnum.JAVANESE) },
    { locale: LocaleEnum.KALAALLISUT, name: localeName(LocaleEnum.KALAALLISUT) },
    { locale: LocaleEnum.KANNADA, name: localeName(LocaleEnum.KANNADA) },
    { locale: LocaleEnum.KANURI, name: localeName(LocaleEnum.KANURI) },
    { locale: LocaleEnum.KASHMIRI, name: localeName(LocaleEnum.KASHMIRI) },
    { locale: LocaleEnum.KAZAKH, name: localeName(LocaleEnum.KAZAKH) },
    { locale: LocaleEnum.KHMER, name: localeName(LocaleEnum.KHMER) },
    { locale: LocaleEnum.KIKUYU, name: localeName(LocaleEnum.KIKUYU) },
    { locale: LocaleEnum.KINYARWANDA, name: localeName(LocaleEnum.KINYARWANDA) },
    { locale: LocaleEnum.KIRGHIZ, name: localeName(LocaleEnum.KIRGHIZ) },
    { locale: LocaleEnum.KOMI, name: localeName(LocaleEnum.KOMI) },
    { locale: LocaleEnum.KONGO, name: localeName(LocaleEnum.KONGO) },
    { locale: LocaleEnum.KOREAN, name: localeName(LocaleEnum.KOREAN) },
    { locale: LocaleEnum.KUANYAMA, name: localeName(LocaleEnum.KUANYAMA) },
    { locale: LocaleEnum.KURDISH, name: localeName(LocaleEnum.KURDISH) },
    { locale: LocaleEnum.LAO, name: localeName(LocaleEnum.LAO) },
    { locale: LocaleEnum.LATIN, name: localeName(LocaleEnum.LATIN) },
    { locale: LocaleEnum.LATVIAN, name: localeName(LocaleEnum.LATVIAN) },
    { locale: LocaleEnum.LIMBURGAN, name: localeName(LocaleEnum.LIMBURGAN) },
    { locale: LocaleEnum.LINGALA, name: localeName(LocaleEnum.LINGALA) },
    { locale: LocaleEnum.LITHUANIAN, name: localeName(LocaleEnum.LITHUANIAN) },
    { locale: LocaleEnum.LUBA_KATANGA, name: localeName(LocaleEnum.LUBA_KATANGA) },
    { locale: LocaleEnum.LUXEMBOURGISH, name: localeName(LocaleEnum.LUXEMBOURGISH) },
    { locale: LocaleEnum.MACEDONIAN, name: localeName(LocaleEnum.MACEDONIAN) },
    { locale: LocaleEnum.MALAGASY, name: localeName(LocaleEnum.MALAGASY) },
    { locale: LocaleEnum.MALAY, name: localeName(LocaleEnum.MALAY) },
    { locale: LocaleEnum.MALAYALAM, name: localeName(LocaleEnum.MALAYALAM) },
    { locale: LocaleEnum.MALTESE, name: localeName(LocaleEnum.MALTESE) },
    { locale: LocaleEnum.MANX, name: localeName(LocaleEnum.MANX) },
    { locale: LocaleEnum.MAORI, name: localeName(LocaleEnum.MAORI) },
    { locale: LocaleEnum.MARATHI, name: localeName(LocaleEnum.MARATHI) },
    { locale: LocaleEnum.MARSHALLESE, name: localeName(LocaleEnum.MARSHALLESE) },
    { locale: LocaleEnum.MONGOLIAN, name: localeName(LocaleEnum.MONGOLIAN) },
    { locale: LocaleEnum.NAURU, name: localeName(LocaleEnum.NAURU) },
    { locale: LocaleEnum.NAVAJO, name: localeName(LocaleEnum.NAVAJO) },
    { locale: LocaleEnum.NDEBELE, name: localeName(LocaleEnum.NDEBELE) },
    { locale: LocaleEnum.NDONGA, name: localeName(LocaleEnum.NDONGA) },
    { locale: LocaleEnum.NEPALI, name: localeName(LocaleEnum.NEPALI) },
    { locale: LocaleEnum.NORTH_NDEBELE, name: localeName(LocaleEnum.NORTH_NDEBELE) },
    { locale: LocaleEnum.NORTHERN_SAMI, name: localeName(LocaleEnum.NORTHERN_SAMI) },
    { locale: LocaleEnum.NORWEGIAN, name: localeName(LocaleEnum.NORWEGIAN) },
    { locale: LocaleEnum.NORWEGIAN_BOKMAL, name: localeName(LocaleEnum.NORWEGIAN_BOKMAL) },
    { locale: LocaleEnum.NORWEGIAN_NYNORSK, name: localeName(LocaleEnum.NORWEGIAN_NYNORSK) },
    { locale: LocaleEnum.NUOSU, name: localeName(LocaleEnum.NUOSU) },
    { locale: LocaleEnum.OCCITAN, name: localeName(LocaleEnum.OCCITAN) },
    { locale: LocaleEnum.OLD_CHURCH_SLAVONIC, name: localeName(LocaleEnum.OLD_CHURCH_SLAVONIC) },
    { locale: LocaleEnum.ORIYA, name: localeName(LocaleEnum.ORIYA) },
    { locale: LocaleEnum.OROMO, name: localeName(LocaleEnum.OROMO) },
    { locale: LocaleEnum.OSSETIAN, name: localeName(LocaleEnum.OSSETIAN) },
    { locale: LocaleEnum.PALI, name: localeName(LocaleEnum.PALI) },
    { locale: LocaleEnum.PANJABI, name: localeName(LocaleEnum.PANJABI) },
    { locale: LocaleEnum.PASHTO, name: localeName(LocaleEnum.PASHTO) },
    { locale: LocaleEnum.PERSIAN, name: localeName(LocaleEnum.PERSIAN) },
    { locale: LocaleEnum.POLISH, name: localeName(LocaleEnum.POLISH) },
    { locale: LocaleEnum.PORTUGUESE, name: localeName(LocaleEnum.PORTUGUESE) },
    { locale: LocaleEnum.QUECHUA, name: localeName(LocaleEnum.QUECHUA) },
    { locale: LocaleEnum.ROMANSH, name: localeName(LocaleEnum.ROMANSH) },
    { locale: LocaleEnum.ROMANIAN, name: localeName(LocaleEnum.ROMANIAN) },
    { locale: LocaleEnum.RUNDI, name: localeName(LocaleEnum.RUNDI) },
    { locale: LocaleEnum.RUSSIAN, name: localeName(LocaleEnum.RUSSIAN) },
    { locale: LocaleEnum.SAMOAN, name: localeName(LocaleEnum.SAMOAN) },
    { locale: LocaleEnum.SANGO, name: localeName(LocaleEnum.SANGO) },
    { locale: LocaleEnum.SANSKRIT, name: localeName(LocaleEnum.SANSKRIT) },
    { locale: LocaleEnum.SARDINIAN, name: localeName(LocaleEnum.SARDINIAN) },
    { locale: LocaleEnum.SERBIAN, name: localeName(LocaleEnum.SERBIAN) },
    { locale: LocaleEnum.SHONA, name: localeName(LocaleEnum.SHONA) },
    { locale: LocaleEnum.SINDHI, name: localeName(LocaleEnum.SINDHI) },
    { locale: LocaleEnum.SINHALA, name: localeName(LocaleEnum.SINHALA) },
    { locale: LocaleEnum.SLOVAK, name: localeName(LocaleEnum.SLOVAK) },
    { locale: LocaleEnum.SLOVENIAN, name: localeName(LocaleEnum.SLOVENIAN) },
    { locale: LocaleEnum.SOMALI, name: localeName(LocaleEnum.SOMALI) },
    { locale: LocaleEnum.SOUTHERN_SOTHO, name: localeName(LocaleEnum.SOUTHERN_SOTHO) },
    { locale: LocaleEnum.SPANISH, name: localeName(LocaleEnum.SPANISH) },
    { locale: LocaleEnum.SUNDANESE, name: localeName(LocaleEnum.SUNDANESE) },
    { locale: LocaleEnum.SWAHILI, name: localeName(LocaleEnum.SWAHILI) },
    { locale: LocaleEnum.SWATI, name: localeName(LocaleEnum.SWATI) },
    { locale: LocaleEnum.SWEDISH, name: localeName(LocaleEnum.SWEDISH) },
    { locale: LocaleEnum.TAGALOG, name: localeName(LocaleEnum.TAGALOG) },
    { locale: LocaleEnum.TAHITIAN, name: localeName(LocaleEnum.TAHITIAN) },
    { locale: LocaleEnum.TAJIK, name: localeName(LocaleEnum.TAJIK) },
    { locale: LocaleEnum.TAMIL, name: localeName(LocaleEnum.TAMIL) },
    { locale: LocaleEnum.TATAR, name: localeName(LocaleEnum.TATAR) },
    { locale: LocaleEnum.TELUGU, name: localeName(LocaleEnum.TELUGU) },
    { locale: LocaleEnum.THAI, name: localeName(LocaleEnum.THAI) },
    { locale: LocaleEnum.TIBETAN, name: localeName(LocaleEnum.TIBETAN) },
    { locale: LocaleEnum.TIGRINYA, name: localeName(LocaleEnum.TIGRINYA) },
    { locale: LocaleEnum.TONGA, name: localeName(LocaleEnum.TONGA) },
    { locale: LocaleEnum.TSONGA, name: localeName(LocaleEnum.TSONGA) },
    { locale: LocaleEnum.TSWANA, name: localeName(LocaleEnum.TSWANA) },
    { locale: LocaleEnum.TURKISH, name: localeName(LocaleEnum.TURKISH) },
    { locale: LocaleEnum.TURKMEN, name: localeName(LocaleEnum.TURKMEN) },
    { locale: LocaleEnum.TWI, name: localeName(LocaleEnum.TWI) },
    { locale: LocaleEnum.UIGHUR, name: localeName(LocaleEnum.UIGHUR) },
    { locale: LocaleEnum.UKRAINIAN, name: localeName(LocaleEnum.UKRAINIAN) },
    { locale: LocaleEnum.URDU, name: localeName(LocaleEnum.URDU) },
    { locale: LocaleEnum.UZBEK, name: localeName(LocaleEnum.UZBEK) },
    { locale: LocaleEnum.VENDA, name: localeName(LocaleEnum.VENDA) },
    { locale: LocaleEnum.VIETNAMESE, name: localeName(LocaleEnum.VIETNAMESE) },
    { locale: LocaleEnum.VOLAPUK, name: localeName(LocaleEnum.VOLAPUK) },
    { locale: LocaleEnum.WALLOON, name: localeName(LocaleEnum.WALLOON) },
    { locale: LocaleEnum.WELSH, name: localeName(LocaleEnum.WELSH) },
    { locale: LocaleEnum.WESTERN_FRISIAN, name: localeName(LocaleEnum.WESTERN_FRISIAN) },
    { locale: LocaleEnum.WOLOF, name: localeName(LocaleEnum.WOLOF) },
    { locale: LocaleEnum.XHOSA, name: localeName(LocaleEnum.XHOSA) },
    { locale: LocaleEnum.YIDDISH, name: localeName(LocaleEnum.YIDDISH) },
    { locale: LocaleEnum.YORUBA, name: localeName(LocaleEnum.YORUBA) },
    { locale: LocaleEnum.ZHUANG, name: localeName(LocaleEnum.ZHUANG) },
    { locale: LocaleEnum.ZULU, name: localeName(LocaleEnum.ZULU) },
];
export const countryCodeOfLocale = (locale) => {
    switch (locale) {
        case LocaleEnum.AFAR:
            return 'ET';
        case LocaleEnum.ABKHAZIAN:
            return 'GE';
        case LocaleEnum.AFRIKAANS:
            return 'ZA';
        case LocaleEnum.AKAN:
            return 'GH';
        case LocaleEnum.ALBANIAN:
            return 'AL';
        case LocaleEnum.AMHARIC:
            return 'ET';
        case LocaleEnum.ARABIC:
            return 'SA';
        case LocaleEnum.ARAGONESE:
            return 'ES';
        case LocaleEnum.ASSAMESE:
            return 'IN';
        case LocaleEnum.AVARIC:
            return 'RU';
        case LocaleEnum.AVESTAN:
            return 'IR';
        case LocaleEnum.AYMARA:
            return 'BO';
        case LocaleEnum.AZERBAIJANI:
            return 'AZ';
        case LocaleEnum.BAMBARA:
            return 'ML';
        case LocaleEnum.BASHKIR:
            return 'RU';
        case LocaleEnum.BASQUE:
            return 'ES';
        case LocaleEnum.BELARUSIAN:
            return 'BY';
        case LocaleEnum.BENGALI:
            return 'BD';
        case LocaleEnum.BIHARI_LANGUAGES:
            return 'IN';
        case LocaleEnum.BISLAMA:
            return 'VU';
        case LocaleEnum.BOSNIAN:
            return 'BA';
        case LocaleEnum.BRETON:
            return 'FR';
        case LocaleEnum.BULGARIAN:
            return 'BG';
        case LocaleEnum.BURMESE:
            return 'MM';
        case LocaleEnum.CATALAN:
            return 'ES';
        case LocaleEnum.CHAMORRO:
            return 'GU';
        case LocaleEnum.CHECHEN:
            return 'RU';
        case LocaleEnum.CHICHEWA:
            return 'MW';
        case LocaleEnum.CHINESE:
            return 'CN';
        case LocaleEnum.CHUVASH:
            return 'RU';
        case LocaleEnum.CORNISH:
            return 'GB';
        case LocaleEnum.CORSICAN:
            return 'FR';
        case LocaleEnum.CREE:
            return 'CA';
        case LocaleEnum.CROATIAN:
            return 'HR';
        case LocaleEnum.CZECH:
            return 'CZ';
        case LocaleEnum.DANISH:
            return 'DK';
        case LocaleEnum.DIVEHI:
            return 'MV';
        case LocaleEnum.DUTCH:
            return 'NL';
        case LocaleEnum.DZONGKHA:
            return 'BT';
        case LocaleEnum.ENGLISH:
            return 'GB';
        case LocaleEnum.ESPERANTO:
            return 'EO';
        case LocaleEnum.ESTONIAN:
            return 'EE';
        case LocaleEnum.EWE:
            return 'GH';
        case LocaleEnum.FAROESE:
            return 'FO';
        case LocaleEnum.FIJIAN:
            return 'FJ';
        case LocaleEnum.FINNISH:
            return 'FI';
        case LocaleEnum.FRENCH:
            return 'FR';
        case LocaleEnum.FULAH:
            return 'SN';
        case LocaleEnum.GALICIAN:
            return 'ES';
        case LocaleEnum.GANDA:
            return 'UG';
        case LocaleEnum.GEORGIAN:
            return 'GE';
        case LocaleEnum.GERMAN:
            return 'DE';
        case LocaleEnum.GREEK:
            return 'GR';
        case LocaleEnum.GUARANI:
            return 'PY';
        case LocaleEnum.GUJARATI:
            return 'IN';
        case LocaleEnum.HAITIAN:
            return 'HT';
        case LocaleEnum.HAUSA:
            return 'NG';
        case LocaleEnum.HEBREW:
            return 'IL';
        case LocaleEnum.HERERO:
            return 'NA';
        case LocaleEnum.HINDI:
            return 'IN';
        case LocaleEnum.HIRI_MOTU:
            return 'PG';
        case LocaleEnum.HUNGARIAN:
            return 'HU';
        case LocaleEnum.ICELANDIC:
            return 'IS';
        case LocaleEnum.IDO:
            return 'IO';
        case LocaleEnum.IGBO:
            return 'NG';
        case LocaleEnum.INDONESIAN:
            return 'ID';
        case LocaleEnum.INTERLINGUA:
            return 'FR';
        case LocaleEnum.INTERLINGUE:
            return 'FR';
        case LocaleEnum.INUKTITUT:
            return 'CA';
        case LocaleEnum.INUPIAQ:
            return 'US';
        case LocaleEnum.IRISH:
            return 'IE';
        case LocaleEnum.ITALIAN:
            return 'IT';
        case LocaleEnum.JAPANESE:
            return 'JP';
        case LocaleEnum.JAVANESE:
            return 'ID';
        case LocaleEnum.KALAALLISUT:
            return 'GL';
        case LocaleEnum.KANNADA:
            return 'IN';
        case LocaleEnum.KANURI:
            return 'NG';
        case LocaleEnum.KASHMIRI:
            return 'IN';
        case LocaleEnum.KAZAKH:
            return 'KZ';
        case LocaleEnum.KHMER:
            return 'KH';
        case LocaleEnum.KIKUYU:
            return 'KE';
        case LocaleEnum.KINYARWANDA:
            return 'RW';
        case LocaleEnum.KIRGHIZ:
            return 'KG';
        case LocaleEnum.KOMI:
            return 'RU';
        case LocaleEnum.KONGO:
            return 'CG';
        case LocaleEnum.KOREAN:
            return 'KR';
        case LocaleEnum.KUANYAMA:
            return 'NA';
        case LocaleEnum.KURDISH:
            return 'IQ';
        case LocaleEnum.LAO:
            return 'LA';
        case LocaleEnum.LATIN:
            return 'VA';
        case LocaleEnum.LATVIAN:
            return 'LV';
        case LocaleEnum.LIMBURGAN:
            return 'NL';
        case LocaleEnum.LINGALA:
            return 'CD';
        case LocaleEnum.LITHUANIAN:
            return 'LT';
        case LocaleEnum.LUBA_KATANGA:
            return 'CD';
        case LocaleEnum.LUXEMBOURGISH:
            return 'LU';
        case LocaleEnum.MACEDONIAN:
            return 'MK';
        case LocaleEnum.MALAGASY:
            return 'MG';
        case LocaleEnum.MALAY:
            return 'MY';
        case LocaleEnum.MALAYALAM:
            return 'IN';
        case LocaleEnum.MALTESE:
            return 'MT';
        case LocaleEnum.MANX:
            return 'IM';
        case LocaleEnum.MAORI:
            return 'NZ';
        case LocaleEnum.MARATHI:
            return 'IN';
        case LocaleEnum.MARSHALLESE:
            return 'MH';
        case LocaleEnum.MONGOLIAN:
            return 'MN';
        case LocaleEnum.NAURU:
            return 'NR';
        case LocaleEnum.NAVAJO:
            return 'US';
        case LocaleEnum.NDEBELE:
            return 'ZW';
        case LocaleEnum.NDONGA:
            return 'AO';
        case LocaleEnum.NEPALI:
            return 'NP';
        case LocaleEnum.NORTH_NDEBELE:
            return 'ZA';
        case LocaleEnum.NORTHERN_SAMI:
            return 'NO';
        case LocaleEnum.NORWEGIAN:
            return 'NO';
        case LocaleEnum.NORWEGIAN_BOKMAL:
            return 'NO';
        case LocaleEnum.NORWEGIAN_NYNORSK:
            return 'NO';
        case LocaleEnum.NUOSU:
            return 'CN';
        case LocaleEnum.OCCITAN:
            return 'FR';
        case LocaleEnum.OJIBWE:
            return 'CA';
        case LocaleEnum.OLD_CHURCH_SLAVONIC:
            return 'MK';
        case LocaleEnum.ORIYA:
            return 'IN';
        case LocaleEnum.OROMO:
            return 'ET';
        case LocaleEnum.OSSETIAN:
            return 'RU';
        case LocaleEnum.PALI:
            return 'LK';
        case LocaleEnum.PANJABI:
            return 'IN';
        case LocaleEnum.PASHTO:
            return 'AF';
        case LocaleEnum.PERSIAN:
            return 'IR';
        case LocaleEnum.POLISH:
            return 'PL';
        case LocaleEnum.PORTUGUESE:
            return 'PT';
        case LocaleEnum.QUECHUA:
            return 'PE';
        case LocaleEnum.ROMANSH:
            return 'CH';
        case LocaleEnum.ROMANIAN:
            return 'RO';
        case LocaleEnum.RUNDI:
            return 'BI';
        case LocaleEnum.RUSSIAN:
            return 'RU';
        case LocaleEnum.SAMOAN:
            return 'WS';
        case LocaleEnum.SANGO:
            return 'CF';
        case LocaleEnum.SANSKRIT:
            return 'IN';
        case LocaleEnum.SARDINIAN:
            return 'IT';
        case LocaleEnum.SERBIAN:
            return 'RS';
        case LocaleEnum.SHONA:
            return 'ZW';
        case LocaleEnum.SINDHI:
            return 'IN';
        case LocaleEnum.SINHALA:
            return 'LK';
        case LocaleEnum.SLOVAK:
            return 'SK';
        case LocaleEnum.SLOVENIAN:
            return 'SI';
        case LocaleEnum.SOMALI:
            return 'SO';
        case LocaleEnum.SOUTHERN_SOTHO:
            return 'LS';
        case LocaleEnum.SPANISH:
            return 'ES';
        case LocaleEnum.SUNDANESE:
            return 'ID';
        case LocaleEnum.SWAHILI:
            return 'TZ';
        case LocaleEnum.SWATI:
            return 'SZ';
        case LocaleEnum.SWEDISH:
            return 'SE';
        case LocaleEnum.TAGALOG:
            return 'PH';
        case LocaleEnum.TAHITIAN:
            return 'PF';
        case LocaleEnum.TAJIK:
            return 'TJ';
        case LocaleEnum.TAMIL:
            return 'IN';
        case LocaleEnum.TATAR:
            return 'RU';
        case LocaleEnum.TELUGU:
            return 'IN';
        case LocaleEnum.THAI:
            return 'TH';
        case LocaleEnum.TIBETAN:
            return 'CN';
        case LocaleEnum.TIGRINYA:
            return 'ER';
        case LocaleEnum.TONGA:
            return 'TO';
        case LocaleEnum.TSONGA:
            return 'ZA';
        case LocaleEnum.TSWANA:
            return 'BW';
        case LocaleEnum.TURKISH:
            return 'TR';
        case LocaleEnum.TURKMEN:
            return 'TM';
        case LocaleEnum.TWI:
            return 'GH';
        case LocaleEnum.UIGHUR:
            return 'CN';
        case LocaleEnum.UKRAINIAN:
            return 'UA';
        case LocaleEnum.URDU:
            return 'PK';
        case LocaleEnum.UZBEK:
            return 'UZ';
        case LocaleEnum.VENDA:
            return 'ZA';
        case LocaleEnum.VIETNAMESE:
            return 'VN';
        case LocaleEnum.VOLAPUK:
            return 'GB';
        case LocaleEnum.WALLOON:
            return 'BE';
        case LocaleEnum.WELSH:
            return 'GB';
        case LocaleEnum.WESTERN_FRISIAN:
            return 'NL';
        case LocaleEnum.WOLOF:
            return 'SN';
        case LocaleEnum.XHOSA:
            return 'ZA';
        case LocaleEnum.YIDDISH:
            return 'IL';
        case LocaleEnum.YORUBA:
            return 'NG';
        case LocaleEnum.ZHUANG:
            return 'CN';
        case LocaleEnum.ZULU:
            return 'ZA';
        default:
            return '';
    }
};
